<div class="image-widget">
  @if (showPlaceholder) {
    <gb-presenter-widget-placeholder>
      <h1 [translate]="placeholderTitleTranslateKey"></h1>
      <span [translate]="placeholderBodyTranslateKey"></span>
    </gb-presenter-widget-placeholder>
  } @else {
    <gb-image [imageSize]="ImageSizeEnum.Full" [image]="imageEntity" [cover]="cover"></gb-image>
  }
</div>
